import { Link } from '@mui/material';
import { GridColDef } from '@mui/x-data-grid-premium';
import { useTranslation } from 'react-i18next';

import { Enum } from '~/data/enums';
import { DocumentsEntry } from '~/scenes/PeopleModule/components/Tabs/DocumentsTab/DocumentsTable/data';
import { getEmployeeAttachmentUrl } from '~/utils/helper';

type PropsType = {
  selectedEmployeeId: number;
  documentTypes: Enum[];
};

export const useReadOnlyDocumentsTableColumns = (props: PropsType) => {
  const { documentTypes, selectedEmployeeId } = props;

  const { t } = useTranslation();

  const dateColumnSizeProps = {
    flex: 0.3,
    minWidth: 130,
  };

  const columns: GridColDef<DocumentsEntry>[] = [
    {
      field: 'type',
      headerName: t('laDocumentType'),
      type: 'singleSelect',
      flex: 0.5,
      minWidth: 140,
      valueOptions: documentTypes.map((e) => e.code),
      valueFormatter: ({ value }) => {
        return documentTypes.find((e) => e.code === value)?.name ?? value ?? '';
      },
    },
    {
      field: 'created',
      headerName: t('laCreatedTime'),
      type: 'date',
      ...dateColumnSizeProps,
    },
    {
      field: 'modified',
      headerName: t('laModifiedTime'),
      type: 'date',
      ...dateColumnSizeProps,
    },
    {
      field: 'name',
      headerName: t('laDocumentName'),
      flex: 1.5,
      minWidth: 200,
      renderCell: ({ value, row }) => {
        return (
          <Link
            href={getEmployeeAttachmentUrl(selectedEmployeeId, row.id)}
            target={'_blank'}
          >
            {value}
          </Link>
        );
      },
    },
  ];

  return {
    columns,
  };
};
